/**
 * Created by denishuang on 2017/8/9.
 */
import {Register} from 'vue-django/src/utils/app_model'

let apps = {
    'exam': {
        verbose_name: '测验',
        models: {
            'paper': {
                verbose_name: '试卷'
            },
            'exam': {
                verbose_name: '考试',
                actions: [
                    {name: 'create', title: '创建', permission: 'post'},
                ]
            },
            'answer': {
                verbose_name: '答卷'
            }
        }
    },
    'course': {
        verbose_name: '课程',
        models: {
            'course': {
                verbose_name: '课程'
            },
            'chapter': {
                verbose_name: '章节'
            }
        }
    },
    'survey': {
        verbose_name: '调查问卷',
        models: {
            'survey': {
                verbose_name: '问卷'
            },
            'answer': {
                verbose_name: '答卷'
            }
        }
    },
    'todo': {
        verbose_name: '待办',
        models: {
            'todo': {
                verbose_name: '待办'
            }
        }
    },
    'media': {
        verbose_name: '多媒体',
        models: {
            'video': {
                verbose_name: '视频'
            },
            'lecturer': {
                verbose_name: '讲师'
            },
            'image': {
                verbose_name: '图片'
            }
        }
    },
    'contenttypes': {
        verbose_name: '类别',
        models: {
            'contenttype': {
                verbose_name: '类别'
            }
        }
    },
    'comment': {
        verbose_name: '评论',
        models: {
            'comment': {
                verbose_name: '评论'
            }
        }
    },
    'points': {
        verbose_name: '积分',
        models: {
            'category': {
                verbose_name: '榜单'
            }
        }
    },
    'clockin': {
        verbose_name: '打卡',
        icon: 'check',
        models: {
            'project': {
                verbose_name: '计划',
                icon: 'home'
            },
            'group': {
                verbose_name: '小组',
                icon: 'home'
            },
            'session': {
                verbose_name: '周期',
                icon: 'clock-o'
            }
        }

    }
}

Register.register(apps)

export default apps



// WEBPACK FOOTER //
// ./src/configs/apps.js